import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { requestSmartTableCellReconciliation } from "@/queries/smart-tables/cellConvergence";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useCancelRows = () => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const wid = Number(workspaceId);

  return useMutation<unknown, unknown, { tableId: string; sheetId: string; row_indices: number[] }>(
    {
      mutationKey: ["smart-tables", "cancel-rows"],
      mutationFn: async ({ tableId, sheetId, row_indices }) => {
        const response = await fetch(ENDPOINTS.smart_table_rows_cancel(wid, tableId, sheetId), {
          method: "POST",
          headers: jsonAuthHeaders(userToken),
          body: JSON.stringify({ row_indices }),
        });
        return handleResponse(response);
      },
      onSuccess: (_response, { tableId, sheetId }) => {
        requestSmartTableCellReconciliation({ tableId, sheetId, reason: "cancellation" });
      },
    },
  );
};
